import Icon from "app/components/shared/Icon";

import {
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
} from "app/components/shared/PopoverNext";
import Examples from "./Examples";

export default function ExamplePicker({ examplesPath }: { examplesPath: string }) {
  return (
    <Popover>
      <PopoverTrigger asChild={true}>
        <button className="flex h-8 shrink-0 items-center gap-1 rounded bg-purple-100 px-2.5 font-medium text-purple-600">
          Try an example
          <Icon icon="down-triangle" className="size-2" />
        </button>
      </PopoverTrigger>

      <PopoverPortal>
        <PopoverContent
          alignOffset={0}
          align="end"
          data-testid="example-picker-popover"
          className="max-h-96 w-80 overflow-y-auto p-0"
        >
          <Examples examplesPath={examplesPath} />
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
}
